module.exports = __webpack_public_path__ + "img/17.14ed8301.png";